angular.module('blc').controller('ContactController', ContactController);
ContactController.$inject = ['$scope', '$element', '$http', 'quote', 'redcontrol'];
function ContactController($scope, $element, $http, quote,redcontrol) {
  $scope.contact_data = {} 
  $scope.state = 'ready'
  $scope.send_contact = function(evt) {
    $scope.state = 'sending';
    $http({
      method: 'post',
      url: '/contact',
      data: this.contact_data
    }).success( function(res) {
      $scope.state = 'sent'
      $scope.contact_data = {}
      redcontrol.popup=null
    })
  }
}



/*****************
 ** WEBPACK FOOTER
 ** ./gulp/assets/javascripts/contact-controller.js
 ** module id = 30
 ** module chunks = 0
 **/